var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v(_vm._s(_vm.Lang.get('messages.delete_confirmation'))+" "),(_vm.message)?_c('span',[_vm._v("( "+_vm._s(_vm.message)+" )")]):_vm._e(),_vm._v("؟")])}
var staticRenderFns = []

export { render, staticRenderFns }